import camelcaseKeys from 'camelcase-keys'
import {
  ApolloClient,
  createHttpLink,
  ApolloLink,
  from,
  InMemoryCache
} from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import * as Sentry from '@sentry/vue'

import { redirectLogin } from '@/utils/idaas'

const httpLink = createHttpLink({
  uri: '/graphql/okr'
})

const camelcaseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    response.data = camelcaseKeys(response.data, { deep: true })
    return response
  })
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      Sentry.captureMessage(message)
    })
  }

  if (networkError) {
    const error = networkError?.result?.error
    if (error && error.code === 100) {
      redirectLogin(error.ssourl)
      return
    }
    console.log(`[Network error]: ${networkError}`)
    Sentry.captureException(networkError)
  }
})

const cache = new InMemoryCache()

const apolloClient = new ApolloClient({
  link: from([
    errorLink,
    camelcaseLink,
    httpLink
  ]),
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache'
    }
  }
})

export default apolloClient
